import $ from 'jquery';

/* global x5script */

class CoursesFilter {
  constructor() {
    this.filter = $('.js-courses-filter');
    this.filterForm = this.filter.find('.js-courses-filter-form');

    if (!this.filter.length) {
      return;
    }

    this.selectFieldsStatic();
    // this.tagSearch();
  }

  tagSearch() {
    this.tagSelect = this.filter.find('.js-select-tag');

    if (!this.tagSelect.length) {
      return;
    }

    this.tagSelect.each((i, el) => {
      const select = $(el);
      const defaultValue = select.data('default');

      select.select2({
        placeholder: select.data('placeholder'),
        allowClear: true,
        minimumResultsForSearch: 0,
        ajax: {
          url: x5script.ajaxurl,
          dataType: 'json',
          data: params => ({
            search: params.term,
            tags_security: x5script.tags_security,
            action: 'courses_tag_search',
          }),
          processResults: data => ({
            results: data,
          }),
        },
      });

      // select
      //   .parent()
      //   .find('.select2-selection__arrow')
      //   .hide();

      if (defaultValue.trim() !== '') {
        const data = {
          search: defaultValue,
          tags_security: x5script.tags_security,
          action: 'courses_tag_search',
        };

        $.get(x5script.ajaxurl, data, response => {
          if (response.error) {
            // error
          } else if (response[0]) {
            const option = new Option(
              response[0].text,
              response[0].id,
              true,
              true,
            );
            select.append(option).trigger('change');
          }

          this.filter
            .find('.is-fadein')
            .css({
              visibility: 'visible',
              opacity: 0,
            })
            .stop()
            .animate(
              {
                opacity: 1,
              },
              300,
            );
        });
      }
    });
  }

  selectFieldsStatic() {
    this.select = this.filter.find('.js-select');

    if (!this.select.length) {
      return;
    }

    this.selectionsContainer = $('.js-courses-filter-selections');

    this.select.each((i, el) => {
      const select = $(el);
      const defaultValue = select.attr('data-default');
      const isMultiple = select.attr('multiple') === 'multiple';

      select.select2({
        placeholder: select.attr('data-placeholder'),
        allowClear: true,
        minimumResultsForSearch: -1,
        closeOnSelect: true,
      });

      if (isMultiple) {
        const multiSelect = select
          .parent()
          .find('.select2-selection--multiple');

        if (multiSelect.length) {
          const multiselectGroup = multiSelect.closest('.js-form-group');
          const multiSelectField = multiselectGroup.find('.js-select');

          multiSelect.append(
            `<span class="select2-selection__placeholder">${multiSelectField.attr(
              'data-placeholder',
            )}</span>`,
          );
          multiSelect.append(
            '<span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>',
          );

          if (
            multiSelectField.val() !== null &&
            multiSelectField.val().length
          ) {
            multiselectGroup.find('.select2-selection__placeholder').hide();
          }
        }
      }

      select.on('select2:select select2:unselect', event => {
        const selectField = $(`#${event.target.id}`);
        const selectBox = selectField.parent();
        const placeholder = selectBox.find('.select2-selection__placeholder');

        if (selectField.val() === null || event.params.isClear) {
          placeholder.show();
        } else {
          placeholder.hide();
        }
      });

      select.on('change', event => {
        const selectField = $(`#${event.target.id}`);
        const selectBox = selectField.parent();

        if (isMultiple) {
          selectBox.find('.select2-selection__rendered li').hide();

          const choices = selectBox.find('.select2-selection__choice');

          if (choices.length) {
            choices.each((index, choice) => {
              if (!$(choice).attr('title')) {
                $(choice).remove();
              }
            });
          }

          const count = selectBox.find('.select2-selection__choice').length;
          selectBox.find('.select2-selection__choice-count').remove();

          if (count > 0) {
            selectBox
              .find('.select2-selection__rendered')
              .append(
                `<div class="select2-selection__choice-count">${count} selected</div>`,
              )
              .prepend(
                `<span class="selection__clear js-selection-clear">×</span>`,
              );

            this.clearMultiple();
          }
        }

        setTimeout(() => {
          this.renderSelectionsHtml();
        });
      });

      if (defaultValue.trim() !== '') {
        if (isMultiple) {
          select.val(defaultValue.split(',')).trigger('change');

          if (select.val() !== null) {
            select
              .parent()
              .find('.select2-selection__placeholder')
              .hide();
          }
        } else {
          select.val(defaultValue);
          select.trigger('change');
        }
      }
    });
  }

  clearMultiple() {
    this.clearButton = $('.js-selection-clear');

    this.clearButton.on('click', e => {
      const self = $(e.currentTarget);
      const select = self.closest('.js-form-group').find('.js-select');

      if (select.length) {
        select
          .val(null)
          .trigger('change')
          .trigger({
            type: 'select2:unselect',
            params: {
              isClear: true,
            },
          });
      }
    });
  }

  filtersReset() {
    this.filtersResetBtn = $('.js-courses-filter-reset');
    this.filtersResetBtn.on('click', e => {
      e.preventDefault();

      this.filterForm
        .find('select')
        .val(null)
        .trigger('change')
        .trigger({
          type: 'select2:unselect',
          params: {
            isClear: true,
          },
        });

      this.filterForm.trigger('submit');
    });
  }

  filterResetSingle() {
    this.resetSingleBtn = $('.js-courses-filter-clear');

    this.resetSingleBtn.on('click', e => {
      const selection = $(e.currentTarget).parent();
      const selectionVal = selection
        .text()
        .slice(0, -1)
        .replace(/(\s|\.|,|;|\(|\))+/g, '-') // replace with dash
        .replace(/-$/g, '') // remove dahs if is a last character
        .toLowerCase();
      const selectId = selection.parent().attr('data-select-id');
      const select = $(`#${selectId}`);
      const selectVal = select.val();

      if (Array.isArray(selectVal)) {
        const newSelectVal = selectVal.filter(value => value !== selectionVal);

        if (newSelectVal.length) {
          select.val(newSelectVal).trigger('change');
        } else {
          select
            .val(newSelectVal)
            .trigger('change')
            .trigger({
              type: 'select2:unselect',
              params: {
                isClear: true,
              },
            });
        }
      } else {
        select
          .val(null)
          .trigger('change')
          .trigger({
            type: 'select2:unselect',
            params: {
              isClear: true,
            },
          });
      }
    });
  }

  renderSelectionsHtml() {
    const selectionClearBtn =
      '<b class="c-courses-filter--clear js-courses-filter-clear">×</b>';
    const resetButton = x5script.isCalendarPage
      ? `<a class="c-btn c-btn--primary c-btn--clear js-courses-filter-reset no-scroll" href="#">${
          x5script.clearFiltersText
        }</a>`
      : `<a class="c-btn c-btn--primary c-btn--clear" href="${
          x5script.coursesResetFilterUrl
        }">${x5script.clearFiltersText}</a>`;

    let html = `<h5>${x5script.selectedFiltersHeader}${resetButton}</h5><ul>`;

    this.select.each((i, el) => {
      const select = $(el);
      const selectId = select.attr('id');
      // let fieldName = selectId.replace('course-', '');
      const isMultiple = select.attr('multiple') === 'multiple';

      const fieldName = select
        .closest('.js-form-group')
        .find(`label[for="${selectId}"]`)
        .text();

      let value = Array.isArray(select.val())
        ? select.val().filter(val => val !== '' && val !== null)
        : select.val();
      value = Array.isArray(value) && value.length === 0 ? '' : value;

      // if (fieldName === 'tag') {
      //   fieldName = 'modules';
      // } else if (fieldName === 'speciality') {
      //   fieldName = 'specialty';
      // }

      if (value !== null && value !== '') {
        if (isMultiple) {
          const labels = value.map(val =>
            select.find(`option[value=${val}]`).text(),
          );
          const values = labels.join(`${selectionClearBtn}</span> <span>`);

          html += `<li data-select-id="${selectId}"><strong>${fieldName}:</strong> <span>${values}${selectionClearBtn}</span></li>`;
        } else {
          const label = select.find(`option[value=${value}]`).text();

          html += `<li data-select-id="${selectId}"><strong>${fieldName}:</strong> <span>${label}${selectionClearBtn}</span></li>`;
        }
      }
    });

    html += '</ul>';

    if (!$(html).find('li').length) {
      html = '';
    }

    this.selectionsContainer.html(html);
    this.filtersReset();
    this.filterResetSingle();
  }
}

export default new CoursesFilter();



// WEBPACK FOOTER //
// ./src/scripts/modules/courses-filter.js